import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import AuditLogs from "./pages/AuditLogs";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Operators from "./pages/Operators";
import ResetPassword from "./pages/ResetPassword";
import TenantDataPage from "./pages/TenantDataPage";
import TenantDetail from "./pages/TenantDetail";
import TenantUsers from "./pages/TenantUsers";
import Tenants from "./pages/Tenants";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/tenants" element={<Tenants />} />
        <Route path="/tenants/:id" element={<TenantDetail />} />
        <Route path="/tenants/:id/users" element={<TenantUsers />} />
        <Route path="/tenants/:id/data/:section" element={<TenantDataPage />} />
        <Route path="/operators" element={<Operators />} />
        <Route path="/audit-logs" element={<AuditLogs />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
